import {
  STATUS_ICON_CHECK_O,
  STATUS_ICON_PENDING,
  STATUS_ICON_TIMES_O,
  STATUS_ICON_LOADING
} from '@/common/utils/statuses';
import computedLocale from '@/common/utils/computedLocale';
import i18n from '@/common/i18n';

export enum FileUploadStatuses {
  UPLOADED = 'UPLOADED',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
  PROGRESS = 'PROGRESS',
}

export interface FileUploadStatusMapItem {
  icon: string;
  text: string;
}

export type FileUploadStatusMap = {
  [key in FileUploadStatuses]: FileUploadStatusMapItem;
};

export const FILE_UPLOAD_STATUS_MAP: FileUploadStatusMap = computedLocale(() => ({
  [FileUploadStatuses.UPLOADED]: {
    icon: STATUS_ICON_CHECK_O,
    text: i18n.t('Uploaded'),
  },
  [FileUploadStatuses.PENDING]: {
    icon: STATUS_ICON_PENDING,
    text: i18n.t('Pending'),
  },
  [FileUploadStatuses.FAILED]: {
    icon: STATUS_ICON_TIMES_O,
    text: i18n.t('Failed'),
  },
  [FileUploadStatuses.CANCELED]: {
    icon: STATUS_ICON_TIMES_O,
    text: i18n.t('Canceled'),
  },
  [FileUploadStatuses.PROGRESS]: {
    icon: STATUS_ICON_LOADING,
    text: '',
  }
}));
